export default class Impfschema {
    public impfschema_code: string | null = null;
    public displayname: string | null = null;
    public impfungindikation_code: string | null = null;
    public ordernumber: number | null = null;

    constructor(data?: Partial<Impfschema>) {
        Object.assign(this, data);
    }
}
